<template>
  <button
    :class="classnames"
    :disabled="disabled"
    :type="type"
    @click="handleClick"
  >
    <span :class="`${ns}__svg`">
      <slot />
    </span>
  </button>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'interactive-svg-icon'

  const modifiers = {
    isActive: 'is-active'
  }

  export default {
    name: 'InteractiveSvgIcon',
    mixins: [ bem ],
    props: {
      disabled: {
        default: false,
        type: Boolean
      },
      type: {
        default: 'button',
        type: String,
        validator: function (value) {
          return [
            'button',
            'submit',
            'reset'
          ].indexOf(value) !== -1
        }
      },
      isActive: {
        default: false,
        type: Boolean
      }
    },
    data () {
      return {}
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {
      classnameModifiers: function () {
        const isActive = this.isActive && modifiers.isActive

        return [ isActive ]
      },
      handleClick: function () {
        this.$emit('click')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/InteractiveSvgIcon.vue